module.exports = __webpack_public_path__ + "Flag-24.49a28e212aa3818ba48c924d3461ccfe.svg";